<template>
  <register-form v-if="pageType === 'OEGG'" />
  <rockbowl-form v-else-if="currentPageType === 'register-rockbowl'" />
  <registration-form v-else-if="pageType != null" :pageType="pageType" />
</template>

<script>
import { pageTypeResource } from "./../api/resources";
import RegistrationForm from "./RegistrationForm";
import RockbowlForm from "./RockbowlForm";
import RegisterForm from "./RegisterForm";

export default {
  components: {
    RegistrationForm,
    RockbowlForm,
    RegisterForm,
  },
  data: () => ({
    pageType: null,
    currentPageType: "",
  }),
  async created() {
    this.currentPageType = window.pageType; // || "register-rockbowl";
    this.pageType = (await pageTypeResource.get()).data.type;
  },
};
</script>
